module.exports = __webpack_public_path__ + "static/media/membership-monthly-lg.33e48ce6.png";